module.exports = __webpack_public_path__ + "img/potential-events_ncaa-final-four.1b5c909f.jpg";